import { render, staticRenderFns } from "./AddEditDocumentDialog.vue?vue&type=template&id=0e9d50b9&scoped=true&lang=pug&"
import script from "./AddEditDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditDocumentDialog.vue?vue&type=style&index=0&id=0e9d50b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9d50b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VContainer,VDivider,VIcon,VProgressLinear,VSkeletonLoader})
